/**
 * Scarica un URL che il server restituisce già in attachment, restando nella pagina.
 * Non usa window.open: dopo un await Safari lo tratta come popup e lo blocca in silenzio.
 */
export const downloadAttachmentUrl = (url: string): void => {
    const a = document.createElement('a');
    a.href = url;
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    a.remove();
};
